/* Copyright 2016-2022
   Kabandy
   Author: Cedric Hoarau
 */

import { ContentType } from "./ContentType";
import { RequestMethod } from "./RequestMethod";

export { ContentType, RequestMethod };
